import React from 'react';
import { Form, Input, Row } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { push as routerPush } from 'react-router-redux';
import URI from 'urijs';

// components
import ViewResults from '../../components/paginator/view-results';
import withField from '../../decorators/with-field';

// containers
import CommercialAdvancedSearch from './AdvancedSearch/CommercialAdvancedSearch';
import LandAdvancedSearch from './AdvancedSearch/LandAdvancedSearch';
import ResidentialAdvancedSearch from './AdvancedSearch/ResidentialAdvancedSearch';
import ResidentialIncomeAdvancedSearch from './AdvancedSearch/ResidentialIncomeAdvancedSearch';
import RentalAdvancedSearch from './AdvancedSearch/RentalAdvancedSearch';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

let PropertySearchAdvancedForm = props => {
  const {
    handleSubmit,
    handleShowResults,
    propertyClass = 'residential',
    pathnameResults
  } = props;

  return (
    <Form onSubmit={handleSubmit} className={styles.advancedSearch}>
      <ViewResults
        listId="properties"
        className={`${BS.mt3}`}
        onShowResults={() => handleShowResults(pathnameResults)}
      />
      <Field name="countOnly" type="hidden" component={withField(Input)} />
      <Row className={`${BS.pt3} ${BS.pb1}`}>
        {renderPropertyClassForm(propertyClass)}
      </Row>
      <ViewResults
        listId="properties"
        className={`${BS.mb3}`}
        onShowResults={() => handleShowResults(pathnameResults)}
      />
    </Form>
  );
};

const renderPropertyClassForm = (propertyClass, props) => {
  switch (propertyClass) {
    case 'rental':
      return <RentalAdvancedSearch {...props} />;
    case 'land':
      return <LandAdvancedSearch {...props} />;
    case 'commercial':
      return <CommercialAdvancedSearch {...props} />;
    case 'residential_income':
      return <ResidentialIncomeAdvancedSearch {...props} />;
    case 'residential':
    default:
      return <ResidentialAdvancedSearch {...props} />;
  }
};

// This is to specifically change between the advanced search
// and the advanced search results
let handleShowResults = function (pathname) {
  return routerPush(URI(pathname).search(window.location.search).toString());
};

export default reduxForm({
  form: 'property-search-form'
})(
  connect(
    (state, props) => {
      return {
        totalCount: state.PropertySearch.getIn(['list', 'totalCount'])
      };
    },
    {
      handleShowResults
    }
  )(PropertySearchAdvancedForm)
);



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/PropertySearchAdvancedForm.js